<!-- <div class="modal-header">
  <h4 class="modal-title pull-left">Buy Credit point  </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modelhide()">
    <span aria-hidden="true" style="font-weight: 400; font-size: 26px;">×</span>
  </button>
</div>
<div class="modal-body">
  <p><strong>You don't have credit point please buy point  </strong></p>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="purchesCredit()"> Purchase Credit </button>
</div> -->



   <!-- credits availability checking -->
   <div>
    <!-- [@slide-in]="animState" -->
    <div class="custom-panel-heading">
      <div class="panel-heading"  >
        <div class="row panel-tools">
          <div class="col-sm-2">
            <button type="button" class="close" aria-label="Close" (click)="modelhide()">
              <span style="font-size: 26px;font-weight: 400;" aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>

        <label class="control-label padding-top-0 margin-bottom-5 margin-top-5"
          style="margin-left: 8px !important">message model</label>
      </div>

    </div>
    <div class="panel-body custom-modal-body"   >
      <div class="form-group row header-text">


      </div>
    </div>
    <div class="custom-panel-footer">
      <div class="panel-footer footer-btn"  >
        <div class="shifu">

        </div>
      </div>
    </div>

  </div>
